import React from "react";
import { Row, Col } from "antd";
import ChartCard from "../components/ChartCard";
import RankedProgressBars from "../components/RankedProgressBars";
import { PanelStack } from "../Dashboard.styles";

const pctFormatter = (v) => `${v}%`;

const flattenSubFunctions = (functions) => (functions || []).flatMap((f) => f.sub_function || []);

const CollaborationPanel = ({ collaboration }) => {
  const data = collaboration?.breakdown;
  if (!data) return null;

  const subFunctions = flattenSubFunctions(data.function);

  return (
    <PanelStack>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <ChartCard title="By Legal Entity" subtitle="AI automation % across legal entities">
            <RankedProgressBars
              labels={data.legal_entity.map((r) => r.name)}
              values={data.legal_entity.map((r) => r.value)}
              valueFormatter={pctFormatter}
              basis={100}
            />
          </ChartCard>
        </Col>
        <Col xs={24} md={12}>
          <ChartCard title="By Business Unit" subtitle="AI automation % across the Business Unit">
            <RankedProgressBars
              labels={data.business_unit.map((r) => r.name)}
              values={data.business_unit.map((r) => r.value)}
              valueFormatter={pctFormatter}
              basis={100}
            />
          </ChartCard>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <ChartCard title="By Function" subtitle="AI automation % by Function">
            <RankedProgressBars
              labels={data.function.map((r) => r.name)}
              values={data.function.map((r) => r.value)}
              valueFormatter={pctFormatter}
              basis={100}
              height={280}
            />
          </ChartCard>
        </Col>
        <Col xs={24} md={12}>
          <ChartCard title="By Sub-Function" subtitle="AI automation % by Sub-Function">
            <RankedProgressBars
              labels={subFunctions.map((r) => r.name)}
              values={subFunctions.map((r) => r.value)}
              valueFormatter={pctFormatter}
              basis={100}
              height={280}
            />
          </ChartCard>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <ChartCard title="By Job Level" subtitle="Automation potential varies by seniority">
            <RankedProgressBars
              labels={data.job_level.map((r) => r.name)}
              values={data.job_level.map((r) => r.value)}
              valueFormatter={pctFormatter}
              basis={100}
            />
          </ChartCard>
        </Col>
      </Row>
    </PanelStack>
  );
};

export default CollaborationPanel;
